export const AssetTypes = {
	ILLUSTRATION: 'illustration',
	ILLUSTRATION_BLURRED: 'illustration-blurred',
	ILLUSTRATION_VIDEO: 'illustration-video',
	JOURNAL_NPC: 'journal-npc',
	JOURNAL_NPC_SHADE: 'journal-npc-shade',
	NPC: 'npc',
	NPC_BODY: 'npc-body',
	NPC_BODY_FRONT: 'npc-body-front',
	NPC_EYEBROW: 'npc-eyebrow',
	NPC_EYELID: 'npc-eyelid',
	NPC_EYELID_HALF_CLOSED: 'npc-eyelid-half-closed',
	NPC_EYELID_CLOSED: 'npc-eyelid-closed',
	NPC_EYEWHITE: 'npc-eyewhite',
	NPC_EYEPUPIL: 'npc-eyepupil',
	NPC_MOUTH: 'npc-mouth',
	NPC_TEARS: 'npc-tears',
	PLACE: 'place',
	SOUND: 'sound',
} as const

export type AssetType = (typeof AssetTypes)[keyof typeof AssetTypes]

export const AssetExtensions = {
	JPG: 'jpg',
	PNG: 'png',
	WEBP: 'webp',
	AVIF: 'avif',
	MP3: 'mp3',
	OGG: 'ogg',
	MP4: 'mp4',
	WEBM: 'webm',
} as const

export type AssetExtension = (typeof AssetExtensions)[keyof typeof AssetExtensions]

export const AssetCompressionTypes = {
	AVIF: 'avif',
	WEBP: 'webp',
	H264: 'h264',
	H265: 'h265',
	WEBM: 'webm',
	OGG: 'ogg',
} as const

export type AssetCompressionType = (typeof AssetCompressionTypes)[keyof typeof AssetCompressionTypes]

export const AssetFormats = {
	ORIGINAL: 'original',
	HD: 'hd',
	THUMBNAIL: 'thumbnail',
} as const

export type AssetFormat = (typeof AssetFormats)[keyof typeof AssetFormats]
export type AssetMap<T> = { [AssetFormats.HD]: T } & { [key in Exclude<AssetFormat, typeof AssetFormats.HD>]?: T }
export const assetFormats = Object.values(AssetFormats) as AssetFormat[]

export const AssetPaths: Record<AssetType, string> = {
	[AssetTypes.ILLUSTRATION]: '/illustration',
	[AssetTypes.ILLUSTRATION_BLURRED]: '/illustration/blurred',
	[AssetTypes.ILLUSTRATION_VIDEO]: '/illustration/video',
	[AssetTypes.JOURNAL_NPC]: '/journal/npc',
	[AssetTypes.JOURNAL_NPC_SHADE]: '/journal/npc/shade',
	[AssetTypes.NPC]: '/npc/thumbnail',
	[AssetTypes.NPC_BODY]: '/npc/body',
	[AssetTypes.NPC_BODY_FRONT]: '/npc/body/front',
	[AssetTypes.NPC_EYEBROW]: '/npc/eyebrow',
	[AssetTypes.NPC_EYELID]: '/npc/eyelid',
	[AssetTypes.NPC_EYELID_HALF_CLOSED]: '/npc/eyelid/half-closed',
	[AssetTypes.NPC_EYELID_CLOSED]: '/npc/eyelid/closed',
	[AssetTypes.NPC_EYEWHITE]: '/npc/eyewhite',
	[AssetTypes.NPC_EYEPUPIL]: '/npc/eyepupil',
	[AssetTypes.NPC_MOUTH]: '/npc/mouth',
	[AssetTypes.NPC_TEARS]: '/npc/tears',
	[AssetTypes.PLACE]: '/place',
	[AssetTypes.SOUND]: '/sound',
} as const
